import { Directive, OnInit } from '@angular/core';
import { DxTextBoxComponent } from 'devextreme-angular';

@Directive({
    selector: '[configViewPasswordButton]',
})
export class M4UConfigViewPasswordDirective implements OnInit {

    constructor(private textBox: DxTextBoxComponent) {
    }

    ngOnInit() {
        const button = {
            name: 'viewPassword',
            location: 'after',
            options: {
                icon: 'mdi mdi-eye',
                elementAttr: { class: 'btn-size-small' },
                type: 'normal',
                onClick: (e) => {
                    this.textBox.mode = this.textBox.mode === 'text' ? 'password' : 'text';
                    const icon = this.textBox.mode === 'text' ? 'mdi mdi-eye-off' : 'mdi mdi-eye';
                    e.component.option('icon', icon);
                }
            }
        };
        if (!this.textBox.buttons) { this.textBox.buttons = []; }
        this.textBox.buttons.unshift(button as any);
    }
}
